// utils/encryption.js
import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'your-secure-encryption-key-123';

export const encryptField = (value) => {
  if (!value) return value;
  try {
    return CryptoJS.AES.encrypt(value.toString(), ENCRYPTION_KEY).toString();
  } catch (error) {
    console.error('Encryption error:', error);
    return value; // Return original if encryption fails
  }
};

export const decryptField = (encryptedValue) => {
  if (!encryptedValue) return encryptedValue;
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, ENCRYPTION_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption error:', error);
    return encryptedValue;
  }
};